import CryptoJS from 'crypto-js';

class SecurityInfo {
	constructor(keyPair) {
		this.TRANSFORMATION = 'aes-128-cbc';
		this.AES_KEY_SIZE = 16;
		this.keyPair = keyPair;
	}

	padKeyToSize(key, size) {
		return CryptoJS.enc.Utf8.parse(key.padEnd(size, '\0'));
	}

	encryptAes(data) {
		return this.encryptAesWithKeyAndIv(this.keyPair, data, this.keyPair);
	}

	encryptAesWithKey(key, data) {
		return this.encryptAesWithKeyAndIv(key, data, key);
	}

	encryptAesWithKeyAndIv(key, data, iv) {
		try {
			if (!key || !iv || !data) {
				throw new Error('Key, IV, and data must not be null');
			}

			const keyData = this.padKeyToSize(key, this.AES_KEY_SIZE);
			const ivData = this.padKeyToSize(iv, this.AES_KEY_SIZE);

			const encrypted = CryptoJS.AES.encrypt(data, keyData, { iv: ivData });
			return encrypted.toString();
		} catch (error) {
			console.error('AES Util Encrypt Error', error);
			return '-1';
		}
	}

	decryptAes(encryptedData) {
		return this.decryptAesWithKeyAndIv(this.keyPair, encryptedData, this.keyPair);
	}

	decryptAesWithKey(key, encryptedData) {
		return this.decryptAesWithKeyAndIv(key, encryptedData, key);
	}

	decryptAesWithKeyAndIv(key, encryptedData, iv) {
		try {
			if (!key || !iv || !encryptedData) {
				throw new Error('Key, IV, and encrypted data must not be null');
			}

			const keyData = this.padKeyToSize(key, this.AES_KEY_SIZE);
			const ivData = this.padKeyToSize(iv, this.AES_KEY_SIZE);

			const decrypted = CryptoJS.AES.decrypt(encryptedData, keyData, { iv: ivData });
			return decrypted.toString(CryptoJS.enc.Utf8);
		} catch (error) {
			console.error('AES Util Decrypt Error', error);
			return '-1';
		}
	}

	decryptAesToEuc(key, encryptedData, iv) {
		try {
			if (!key || !iv || !encryptedData) {
				throw new Error('Key, IV, and encrypted data must not be null');
			}

			const decrypted = this.decryptAesWithKeyAndIv(key, encryptedData, iv);
			return decrypted; // Assuming the decrypted data is already in the correct encoding
		} catch (error) {
			console.error('AES Util Decrypt Error', error);
			return '-1';
		}
	}
}

const securityInfo = new SecurityInfo(`${process.env.VUE_APP_KEYPAIR}`);

export default securityInfo;
